angular.module('theme.core.template_overrides', [])
  .config(['$provide', function($provide) {
    $provide.decorator('uibTabsetDirective', function($delegate) {
      var directive = $delegate[0];
      directive.templateUrl = function(element, attr) {
      	if (attr.panelTabs) {
      		if (typeof attr.heading == "undefined") {
      			return 'framework/partials/ui-elements/panel-tabs-without-heading.html';
      		} else {
      			return 'framework/partials/ui-elements/panel-tabs.html';
      		}
      	} else {
      	  if (attr.tabPosition === 'bottom') {
            return 'framework/partials/ui-elements/themed-tabs-bottom.html';
          } else {
          	return 'framework/partials/ui-elements/themed-tabs.html';
          }
      	}
      };

      directive.scope.heading = '@'
      directive.scope.panelClass = '@'
      directive.scope.panelIcon = '@'
      directive.scope.theme = '@tabTheme'
      directive.scope.position = '@tabPosition'
      directive.scope.draggable = '=?ngDrag'

      return $delegate;
    });
  }])
